import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import SeoContentSection from './components/SeoContentSection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoybuy.guru';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYBUY Spreadsheet',
  url: siteUrl,
  description: 'Система заказов товаров из Китая через таблицу YOYBUY Spreadsheet',
  inLanguage: 'ru',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <main>
        <HeroSection />
        <CategorySection />
        <SeoContentSection />
      </main>
      <Footer />
    </>
  );
}